module.exports = __webpack_public_path__ + "static/media/ExportIcon.385846d1.svg";